import React, { useEffect, useState } from "react";
import { Mail, Save } from "lucide-react";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";

export function CateringAccess() {
  const [cfg, setCfg] = useState({ catering_access_code: "", notify_email: "" });
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/admin/events/settings").then((r) => setCfg(r.data)); }, []);
  const save = async () => {
    setLoading(true);
    try { await api.put("/admin/events/settings", cfg); toast.success("Gespeichert"); }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  const inp = "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-[#D62B3A] outline-none";
  return (
    <div className="max-w-xl">
      <h2 className="text-xl font-bold mb-1">Catering-Benachrichtigung</h2>
      <p className="text-sm text-gray-500 mb-6">Empfängeradresse für alle eingehenden Catering-/Veranstaltungsanfragen.</p>
      <div className="bg-white rounded-2xl border border-gray-100 p-6 space-y-5">
        <div>
          <label className="text-sm font-medium text-gray-700 flex items-center gap-2"><Mail className="w-4 h-4 text-[#D62B3A]" /> Empfänger für Catering-Anfragen</label>
          <p className="text-xs text-gray-400 mt-1 mb-2">Alle Catering-/Veranstaltungsanfragen werden an diese Adresse gesendet.</p>
          <input value={cfg.notify_email} onChange={(e) => setCfg({ ...cfg, notify_email: e.target.value })} className={inp} data-testid="catering-email-input" placeholder="bestellung@helium-catering.de" />
        </div>
        <button onClick={save} disabled={loading} className="flex items-center gap-2 bg-[#D62B3A] hover:bg-[#b8232f] text-white font-semibold px-6 py-3 rounded-xl disabled:opacity-60" data-testid="catering-save">
          <Save className="w-4 h-4" /> {loading ? "Speichern…" : "Speichern"}
        </button>
      </div>
    </div>
  );
}
